import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Paper } from '@mui/material';
import axios from 'axios';
import ActionsGrillesTarifairesRenderer from 'components/AgGrid/ActionsGrillesTarifairesRenderer';
import AgGrid from 'components/AgGrid/AgGrid';
import DeletedRenderer from 'components/AgGrid/DeletedRenderer';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router';
import ClipLoader from 'react-spinners/ClipLoader';
import MyButton from '../../components/Layout/MyButton';
import MySelect from '../../components/Layout/MySelect';
import TopBar from '../../components/Layout/TopBar';
import { logError } from '../../components/Utils/FormatData';
import { URL_API } from '../../utils/globalConfig';
import useAuthz from '../../hooks/useAuthz';

const GrilleTarifaire = (props) => {
  const alert = useAlert();
  const navigate = useNavigate();
  const [listeTarifs, setListeTarifs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [authz, user, profil] = useAuthz();
  const [needReload, setNeedReload] = useState(false);
  const [selectedValue, setSelectedValue] = useState({ filterSelected: 1 });
  const [listCenters, setListCenters] = useState([]);

  const columnDefs = [
    {
      headerName: 'Id',
      field: 'tarif_id',
      flex: 1,
      minWidth: 75,
      sortable: true,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Centre',
      field: 'centre_id',
      flex: 1,
      minWidth: 200,
      sortable: true,
      cellStyle: { 'justify-content': 'flex-start' },
      valueGetter: (params) => {
        let centerLabel = '';

        if (params.data.centre_id && listCenters.length > 0) {
          listCenters.map((center) => {
            if (Number(center.id) === Number(params.data.centre_id))
              centerLabel = center.label;
          });
        }

        return centerLabel;
      },
      filter: 'agTextColumnFilter',
    }, {
      headerName: 'Libellé',
      field: 'libelle',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    }, {
      headerName: 'Unité',
      field: 'unite',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: `Date d'effet`,
      field: 'date_effet',
      flex: 1,
      minWidth: 200,
      sortable: true,
      valueFormatter: (params) => (params.data.date_effet ? moment(params.data.date_effet).format('DD/MM/YYYY HH:mm') : '-'),
      filter: 'agDateColumnFilter',
    },
    {
      headerName: 'Date de fin de validité',
      field: 'date_fin_validite',
      flex: 1,
      minWidth: 225,
      sortable: true,
      valueFormatter: (params) => (params.data.date_fin_validite ? moment(params.data.date_fin_validite).format('DD/MM/YYYY HH:mm') : '-'),
      filter: 'agDateColumnFilter',
    },
    {
      headerName: 'Tarif ( HT )',
      field: 'tarif',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agNumberColumnFilter',
    },
    {
      headerName: 'Code analytique',
      field: 'code_comptable',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Description',
      field: 'description',
      flex: 5,
      minWidth: 600,
      sortable: true,
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'statut',
      field: 'deleted',
      sortable: true,
      width: 125,
      cellRenderer: 'deletedRenderer',
      cellStyle: { 'justify-content': 'flex-center' },
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'actions',
      field: '',
      sortable: false,
      cellRenderer: 'actionsGrillesTarifairesRenderer',
      cellRendererParams: { setNeedReload: setNeedReload },
      pinned: 'right',
      cellStyle: { 'justify-content': 'flex-start' },
      width: 100,
    },
  ];
  const [agGridOptions, setAgGridOptions] = useState({
    suppressCellSelection: true,
    suppressHorizontalScroll: false,
    animateRows: true,
    rowClassRules: {
      'user-desactivate': function(params) {
        return params.data.deleted === true;
      },
    }
  });
  const frameworkComponents = {
    actionsGrillesTarifairesRenderer: ActionsGrillesTarifairesRenderer,
    deletedRenderer: DeletedRenderer,
  };

  useEffect(async () => {
    if (profil.profil === 6) {
      alert.error('Vous n\'êtes pas autorisé à accéder à la grille tarifaire');
      navigate('/');
    }
    document.title = 'TE - Gestion de la grille tarifaire';
    await apiGetListCenters();
    getListeTarifs();
  }, []);

  useEffect(async () => {
    setIsLoading(true);
    if (needReload) {
      getListeTarifs();
      setNeedReload(false);
    }
  }, [needReload]);

  const getListeTarifs = () => {
    let deleted;

    if (selectedValue.filterSelected === 3) {
      deleted = '';
    } else {
      deleted = selectedValue.filterSelected !== 1;
    }

    axios({ method: 'get', url: `${URL_API}/grille-tarifaire/full-list`, params: { deleted: deleted, userAction: user.user_id, } })
      .then((response) => {
        setListeTarifs(response.data);
        setIsLoading(false);
      })
      .catch((err) => {
        logError(alert, err);
      });

  };

  const apiGetListCenters = async () => {
    axios({ method: 'get', url: `${URL_API}/localisation/list-all-centers` })
      .then(function(response) {
        setListCenters(response.data);
        setIsLoading(false);
      })
      .catch(function(err) {
        logError(alert, err);
      });
  };

  const changeSelectValue = (e) => {
    setSelectedValue({ ...selectedValue, [e.target.name]: e.target.value });
    setNeedReload(true);
  };

  return (<div style={{ height: '100%' }}>
    <TopBar title='Gestion de la grille tarifaire' className='topbar-contenu' color={props.params.color}
            filterContainer={
              <>
                <MySelect name={'filterSelected'} label={'Filtre'}
                          datas={[{ key: 1, value: 'Tarifs activés' }, { key: 2, value: 'Tarifs archivés' }]}
                          value={selectedValue.filterSelected}
                          handleChange={changeSelectValue} firstValue={{ key: 3, value: 'Tous les tarifs' }} />
              </>
            }
            buttons={
              <div className='topbar-buttons'>
                <MyButton onClick={() => navigate('/panneau-administration/grille-tarifaire/createOrEdit')}
                          icon={faPlus} label={'Créer une grille tarifaire'} />
                <MyButton onClick={() => navigate('/panneau-administration')} icon={''} label={'Retour'} />
              </div>
            }
    />

    <div className='row' style={{ margin: 0, overflow: 'hidden' }}>
      <ClipLoader color='#0094ca' loading={isLoading} size={75}
                  css={'display: flex; margin: 25px;justify-content: center;'} />

      {!isLoading &&
        (<Paper style={{ height: '100%', width: '100%', borderTop: '1px solid #4db4da' }}>
          <AgGrid
            gridName={'ag-grid-grilles-tarifaires'}
            rowData={listeTarifs}
            columnDefs={columnDefs}
            rowHeight={40}
            pagination={false}
            frameworkComponents={frameworkComponents}
            gridOptions={agGridOptions}
            setGridOptions={setAgGridOptions}
            sortable={false}
          />
        </Paper>)
      }
    </div>
  </div>);
};

export default GrilleTarifaire;
